var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { getDefaultAsyncWrapperObj, AsyncRequestStatus, allRequestsHaveCompleted } from "@ane/core/lib/models";
import { SupportedTriggerType, TriggeredScorecardDefaults, reduxActionTypePrefix } from "./module/constants/module.constants.js";
import FeatureResourcesInstance from "@ane/exp-data/lib/resources/FeatureResources";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { combineEpics } from "redux-observable";
import AnalysisResource from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import LegacyAnalysisResource from "@ane/exp-data/lib/resources/AnalysisResource";
import * as _ from "lodash";
import ___default from "lodash";
import { createSelectorCreator, defaultMemoize } from "reselect";
import { expressionParser } from "@ane/antlr/lib/FilterExpression/utils/ExpressionParser";
import { getAnalysisGroupHeaders } from "./module/utils/AnalysisGroupHeaders.js";
import { parseTriggerCondition } from "./module/views/AnalysisTemplate/common/AutoGeneratedTriggering.utils.js";
import { jsxs, jsx } from "react/jsx-runtime";
import { Icon, Spinner } from "@ane/ui-components";
import { mergeStyleSets, getTheme } from "@ane/ui-components/lib/Styling";
import LinkRouteAction from "@ane/ui-components/lib/components/LinkRouteAction/LinkRouteAction";
import { useProgressionScorecardContext } from "./module/views/AnalysisTemplate/ProgressionScorecard/Provider.js";
import { useSelector } from "react-redux";
import { AnalysisResources } from "@ane/summary-app-module/lib/module/views/Analysis/module/AnalysisResources";
import MetricServiceResource from "@ane/exp-data/lib/resources/MetricServiceResource";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var ValidationRequestStatus = /* @__PURE__ */ ((ValidationRequestStatus2) => {
  ValidationRequestStatus2["Completed"] = "Passed";
  ValidationRequestStatus2["Pending"] = "Pending";
  ValidationRequestStatus2["Failed"] = "Failed";
  ValidationRequestStatus2["NotRequired"] = "NotRequired";
  return ValidationRequestStatus2;
})(ValidationRequestStatus || {});
const classNames = mergeStyleSets({
  success: [{ color: getTheme().palette.green }],
  failure: [{ color: getTheme().palette.red }]
});
const ValidationStatus = ({ analysisGroupId, analysisTemplateId }) => {
  const rolloutId = useProgressionScorecardContext((context) => context.featureId);
  const openErrorPanel = useProgressionScorecardContext((context) => context.openErrorPanel);
  const { data: analysisGroupData } = useSelector((state) => getAnalysisGroupAsync(state, { rolloutId }));
  const analysisGroup = _.find(analysisGroupData == null ? void 0 : analysisGroupData.value, (analysisGroup2) => analysisGroup2.id === analysisGroupId);
  const analysisTemplate = _.find(analysisGroup == null ? void 0 : analysisGroup.analysisList, (template) => template.id === analysisTemplateId);
  const { status = "" } = analysisTemplate != null ? analysisTemplate : {};
  const _getIconProps = () => {
    switch (status) {
      case "Passed":
        return { ariaLabel: `${status}`, iconName: "CompletedSolid", className: classNames.success };
      case "Pending":
        return { ariaLabel: `${status}`, iconName: "Running" };
      case "Failed":
        return { ariaLabel: `${status}`, iconName: "Blocked2Solid", className: classNames.failure };
      default:
        return null;
    }
  };
  const _getStatusText = () => {
    switch (status) {
      case "Passed":
        return "Validation succeeded";
      case "Pending":
        return "Validation in progress";
      case "NotRequired":
        return "Not required";
      default:
        return null;
    }
  };
  const iconProps = _getIconProps();
  const statusText = _getStatusText();
  return /* @__PURE__ */ jsxs("span", { children: [
    status !== "Pending" && iconProps && /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, iconProps), { styles: { root: { marginRight: "8px" } } })),
    status === "Pending" && iconProps && /* @__PURE__ */ jsx(Spinner, __spreadProps(__spreadValues({}, iconProps), { size: 0, styles: { root: { marginRight: "8px", display: "inline-block" } } })),
    status === "Failed" && /* @__PURE__ */ jsx(
      LinkRouteAction,
      {
        text: "Validation failed",
        onClick: (ev) => {
          openErrorPanel(analysisGroupId, analysisTemplateId);
          ev.stopPropagation();
        }
      }
    ),
    statusText
  ] });
};
const AnalysisTemplateType = {
  TRIGGERED: "Triggered",
  UNTRIGGERED: "Untriggered"
};
const parseAutomaticAnalysis = (mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit = "") => {
  const { AnalysisRules = [] } = mdsAnalysisConfigData != null ? mdsAnalysisConfigData : {};
  const progressionScorecardDictionary = _.reduce(
    AnalysisRules,
    (resultSoFar, current) => {
      var _a;
      const { Condition = {}, SelectedAnalysisTemplates = [] } = current;
      const conditionStr = parseAnalysisCondition(Condition);
      const includeAnalysisTemplate = !!!assignmentUnit || !(Condition == null ? void 0 : Condition.AssignmentUnits) || !(Condition == null ? void 0 : Condition.AssignmentUnits.length) || ((_a = Condition == null ? void 0 : Condition.AssignmentUnits) != null ? _a : []).includes(assignmentUnit);
      includeAnalysisTemplate && SelectedAnalysisTemplates.forEach((s) => {
        var _a2, _b, _c, _d, _e, _f;
        const tasks = (_d = (_c = (_b = (_a2 = metricsAnalysisTemplates == null ? void 0 : metricsAnalysisTemplates[s]) == null ? void 0 : _a2[IReducerKeys.analysis_template_async]) == null ? void 0 : _b.data) == null ? void 0 : _c.taskSchedule) == null ? void 0 : _d.tasks;
        resultSoFar = __spreadProps(__spreadValues({}, resultSoFar), {
          [s]: {
            id: s,
            name: s,
            lastModifiedDate: "",
            isActive: true,
            type: "Untriggered",
            schedule: convertTasksToDateRangeUnits(tasks),
            conditions: (conditionStr + " " + ((_f = (_e = resultSoFar == null ? void 0 : resultSoFar[s]) == null ? void 0 : _e.conditions) != null ? _f : "")).trim()
          }
        });
      });
      return resultSoFar;
    },
    {}
  );
  return Object.values(progressionScorecardDictionary);
};
const includeAnalysisTemplateAndType = (assignmentUnit, Condition, featureAutoTriggerStateValue) => {
  var _a;
  const includeAnalysisTemplateExpression = !!!assignmentUnit || !(Condition == null ? void 0 : Condition.AssignmentUnits) || !(Condition == null ? void 0 : Condition.AssignmentUnits.length) || ((_a = Condition == null ? void 0 : Condition.AssignmentUnits) != null ? _a : []).includes(assignmentUnit);
  if (featureAutoTriggerStateValue === null || featureAutoTriggerStateValue === void 0 || !featureAutoTriggerStateValue) {
    if (Condition.IsFeatureGateTriggeringSupported === null || Condition.IsFeatureGateTriggeringSupported === void 0) {
      return {
        includeAnalysisTemplate: includeAnalysisTemplateExpression,
        analysisTemplateType: AnalysisTemplateType.UNTRIGGERED
      };
    } else if (Condition.IsFeatureGateTriggeringSupported) {
      return {
        includeAnalysisTemplate: false,
        analysisTemplateType: AnalysisTemplateType.TRIGGERED
      };
    } else {
      return {
        includeAnalysisTemplate: includeAnalysisTemplateExpression,
        analysisTemplateType: AnalysisTemplateType.UNTRIGGERED
      };
    }
  } else {
    if (Condition.IsFeatureGateTriggeringSupported === null || Condition.IsFeatureGateTriggeringSupported === void 0) {
      return {
        includeAnalysisTemplate: includeAnalysisTemplateExpression,
        analysisTemplateType: AnalysisTemplateType.UNTRIGGERED
      };
    } else if (Condition.IsFeatureGateTriggeringSupported) {
      return {
        includeAnalysisTemplate: includeAnalysisTemplateExpression,
        analysisTemplateType: AnalysisTemplateType.TRIGGERED
      };
    } else {
      return {
        includeAnalysisTemplate: false,
        analysisTemplateType: AnalysisTemplateType.UNTRIGGERED
      };
    }
  }
};
const parseAutomaticAnalysisWithFeatureAutoTriggerState = (featureAutoTriggerState, mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit = "") => {
  const { AnalysisRules = [] } = mdsAnalysisConfigData != null ? mdsAnalysisConfigData : {};
  const progressionScorecardDictionary = _.reduce(
    AnalysisRules,
    (resultSoFar, current) => {
      const { Condition = {}, SelectedAnalysisTemplates = [] } = current;
      const conditionStr = parseAnalysisCondition(Condition);
      const { includeAnalysisTemplate, analysisTemplateType } = includeAnalysisTemplateAndType(
        assignmentUnit,
        Condition,
        featureAutoTriggerState == null ? void 0 : featureAutoTriggerState.value
      );
      includeAnalysisTemplate && SelectedAnalysisTemplates.forEach((s) => {
        var _a, _b, _c, _d, _e, _f;
        const tasks = (_d = (_c = (_b = (_a = metricsAnalysisTemplates == null ? void 0 : metricsAnalysisTemplates[s]) == null ? void 0 : _a[IReducerKeys.analysis_template_async]) == null ? void 0 : _b.data) == null ? void 0 : _c.taskSchedule) == null ? void 0 : _d.tasks;
        resultSoFar = __spreadProps(__spreadValues({}, resultSoFar), {
          [s + analysisTemplateType]: {
            id: s,
            name: s,
            lastModifiedDate: "",
            isActive: true,
            type: analysisTemplateType,
            schedule: convertTasksToDateRangeUnits(tasks),
            conditions: (conditionStr + " " + ((_f = (_e = resultSoFar == null ? void 0 : resultSoFar[s + analysisTemplateType]) == null ? void 0 : _e.conditions) != null ? _f : "")).trim()
          }
        });
      });
      return resultSoFar;
    },
    {}
  );
  return Object.values(progressionScorecardDictionary);
};
const parseAnalysisCondition = ({ TrafficFiltersExpression = "" }) => {
  const trafficFilters = expressionParser(TrafficFiltersExpression);
  return Object.keys(trafficFilters).map((filterKey) => {
    const filter = trafficFilters[filterKey];
    const { operator, values } = getBaseValuesAndOperator(filter);
    const isOperatorNotIn = (operator == null ? void 0 : operator.toUpperCase()) === "NOTIN";
    return `${filterKey}: ${isOperatorNotIn ? "not(" : ""}${values.map((v) => v).join(",")}${isOperatorNotIn ? ")" : ""}`;
  }).join(" ");
};
const getBaseValuesAndOperator = (audienceFilter) => {
  if (audienceFilter.type === "Base") {
    const audienceFilterClause = audienceFilter.clause;
    return {
      values: audienceFilterClause.type === "SingleValue" ? [audienceFilterClause.values.toString()] : [...audienceFilterClause.values.map((v) => v.toString())],
      operator: audienceFilterClause.operator
    };
  }
  return { values: [], operator: "" };
};
const getProgressionScorecardItems = (input) => {
  const {
    analysisGroupData,
    featureAutoTriggerState,
    mdsAnalysisConfigData,
    metricsAnalysisTemplates,
    newAnalysisCreated = false,
    assignmentUnit = ""
  } = input;
  const automaticAnalysisTemplateList = EnvironmentService.enableAutoTriggerToggle() ? parseAutomaticAnalysisWithFeatureAutoTriggerState(
    featureAutoTriggerState,
    mdsAnalysisConfigData,
    metricsAnalysisTemplates,
    assignmentUnit
  ) : parseAutomaticAnalysis(mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit);
  const templateList = _.filter(
    _.flatten(
      _.map(analysisGroupData, (analysisGroup) => {
        var _a;
        const conditionStr = parseAnalysisCondition({
          TrafficFiltersExpression: (_a = analysisGroup.analysisCondition) == null ? void 0 : _a.trafficFiltersExpression
        });
        return _.map(analysisGroup.analysisList, (analysisListItem) => __spreadProps(__spreadValues({}, analysisListItem), {
          type: analysisGroup.type,
          analysisGroupId: analysisGroup.id,
          conditions: conditionStr
        }));
      })
    ),
    (template) => template.isActive
  );
  const groups = getAnalysisGroupHeaders(automaticAnalysisTemplateList, analysisGroupData != null ? analysisGroupData : [], newAnalysisCreated);
  const filteredGroups = _.filter(groups, (group) => group.count > 0);
  return { items: [...automaticAnalysisTemplateList, ...templateList], groups: filteredGroups };
};
const getSelectionString = (selectedItems, analysisGroups) => {
  let groups = {};
  _.forEach(selectedItems, (item) => {
    _.forEach(item, (template) => {
      var _a, _b;
      const analysisGroup = _.find(analysisGroups, (group) => group.id === template.analysisGroupId);
      const analysisGroupName = (_a = analysisGroup == null ? void 0 : analysisGroup.name) != null ? _a : "";
      groups = __spreadProps(__spreadValues({}, groups), { [analysisGroupName]: [...(_b = groups == null ? void 0 : groups[analysisGroupName]) != null ? _b : [], template.name] });
    });
  });
  const jsonString = JSON.stringify(groups);
  return jsonString.replace(/[{}:\n\t"]/g, "").replace(/[,]/g, ", ").replace(/[[]/g, " [").trim();
};
const getFeatureGateTriggerCondition = (featureGateTriggerExpression, value) => buildTriggerExpression(
  featureGateTriggerExpression,
  [value],
  "{FeatureGateName}"
  /* feature_gate */
);
const getVariantTriggerCondition = (featureGateTriggerExpression, values) => buildTriggerExpression(
  featureGateTriggerExpression,
  values || [],
  "{VariantName}"
  /* variant */
);
const buildTriggerExpression = (featureGateTriggerExpression, values, token) => values.map((v) => featureGateTriggerExpression.replace(token, v)).join(" OR ");
var TriggerExpressionToken = /* @__PURE__ */ ((TriggerExpressionToken2) => {
  TriggerExpressionToken2["variant"] = "{VariantName}";
  TriggerExpressionToken2["feature_gate"] = "{FeatureGateName}";
  return TriggerExpressionToken2;
})(TriggerExpressionToken || {});
const parseFeatureTriggerValues = (triggerCondition, featureGateTriggerCondition, gateType) => {
  const token = gateType === SupportedTriggerType.feature_variant ? "{VariantName}" : "{FeatureGateName}";
  const partsToRemove = _.split(featureGateTriggerCondition, token);
  const regex = new RegExp(partsToRemove.map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|"), "g");
  const entries = _.split(triggerCondition, " OR ");
  let values = _.map(entries, (entry) => _.replace(entry, regex, ""));
  return _.uniq(values);
};
const getFeatureGateExpressionPrefix = (featureGateTriggerCondition, UseVariantForFeatureGateTriggering) => {
  return !!featureGateTriggerCondition ? UseVariantForFeatureGateTriggering ? _.split(
    featureGateTriggerCondition,
    "{VariantName}"
    /* variant */
  )[0] : _.split(
    featureGateTriggerCondition,
    "{FeatureGateName}"
    /* feature_gate */
  )[0] : "";
};
const getSupportedTriggerType = (triggerExpression, sideStreamTriggerExpression, analysisConfig, useVariantForFeatureTriggering = false) => {
  var _a, _b, _c;
  const { FeatureGateTriggerCondition = "" } = analysisConfig;
  const defaultTriggerExpression = (_c = (_b = (_a = analysisConfig.TriggerFilterConfigs) == null ? void 0 : _a["EventViewSideStream"]) == null ? void 0 : _b.Condition) != null ? _c : "";
  const defaultFeatureGateExpression = getFeatureGateExpressionPrefix(
    FeatureGateTriggerCondition,
    useVariantForFeatureTriggering
  );
  if (triggerExpression === defaultTriggerExpression) {
    if (!!sideStreamTriggerExpression) {
      const { isAutomatic } = parseTriggerCondition(sideStreamTriggerExpression);
      if (isAutomatic)
        return SupportedTriggerType.auto_generate;
      return SupportedTriggerType.side_stream_manual;
    }
    return SupportedTriggerType.no_trigger;
  } else if (!!defaultFeatureGateExpression && _.startsWith(triggerExpression, defaultFeatureGateExpression)) {
    return useVariantForFeatureTriggering ? SupportedTriggerType.feature_variant : SupportedTriggerType.feature_gate;
  } else
    return SupportedTriggerType.manual;
};
const getAnalysisTemplateWithoutValidation = (analysisTemplate) => {
  const _a = analysisTemplate, { status, validationError } = _a, rest = __objRest(_a, ["status", "validationError"]);
  return rest;
};
const getAnalysisGroupWithoutValidation = (analysisGroup) => {
  const _a = analysisGroup, { analysisList } = _a, rest = __objRest(_a, ["analysisList"]);
  return __spreadProps(__spreadValues({}, rest), { analysisList: _.map(analysisList, (template) => getAnalysisTemplateWithoutValidation(template)) });
};
const isAnalysisTemplateValidationComplete = (analysisTemplate, isNewAnalysis = false) => (
  // if analysis is new, validation is not complete if status shows as not required
  // backend shows status as not required for new analysis before validation actually begins
  analysisTemplate.status === ValidationRequestStatus.Completed || analysisTemplate.status === ValidationRequestStatus.Failed || (isNewAnalysis ? false : analysisTemplate.status === ValidationRequestStatus.NotRequired)
);
const isAnalysisGroupValidationPending = (analysisGroup, newAnalysisCreated = false) => {
  const activeTemplates = _.filter(analysisGroup.analysisList, (template) => template.isActive);
  return _.some(
    activeTemplates,
    // newly created analysis will be the last in list
    (template, i) => !isAnalysisTemplateValidationComplete(template, newAnalysisCreated && i === activeTemplates.length - 1)
  );
};
const convertTasksToDateRangeUnits = (tasks) => _.map(tasks, (t) => ({ startUnit: Number(t.start), endUnit: Number(t.end), timeUnit: t.type }));
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);
const getFeatureId = (state, props) => props.rolloutId;
const getAnalysisGroupIds = (state, props) => props.analysisGroupIds;
const getFeaturesData = (state) => _.get(state.progressionScorecard, [IReducerKeys.features]);
const getMdsData = (state) => _.get(state.progressionScorecard, [IReducerKeys.mds_data]);
const getAnalysisData = (state) => _.get(state.progressionScorecard, [IReducerKeys.analysis_data]);
const getMetricsAnalysisTemplateData = (state) => _.get(state.progressionScorecard, [IReducerKeys.metrics_analysis_template_data]);
const getDeleteAnalysisData = (state) => _.get(state.progressionScorecard, [IReducerKeys.analysis_delete_data]);
const getUserAffinity = (state) => _.get(state.currentUserDetails, ["userAffinity"]);
const getRootFeatureAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.root_feature_async], getDefaultAsyncWrapperObj())
);
const getExperimentStepId = createDeepEqualSelector([getRootFeatureAsync], (featureData) => {
  var _a, _b, _c, _d, _e;
  return (_e = (_d = (_c = (_b = (_a = featureData.data) == null ? void 0 : _a.Phases) == null ? void 0 : _b[0]) == null ? void 0 : _c.StepIds) == null ? void 0 : _d[0]) != null ? _e : "";
});
const getManagementGroup = createDeepEqualSelector(
  [getRootFeatureAsync, getUserAffinity],
  (rootFeatureAsync, userAffinityAsync) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.ManagementGroup) != null ? _c : (_b = userAffinityAsync == null ? void 0 : userAffinityAsync.data) == null ? void 0 : _b.managementGroup) != null ? _d : "";
  }
);
const getWorkspaceId = createDeepEqualSelector(
  [getRootFeatureAsync, getUserAffinity],
  (rootFeatureAsync, userAffinityAsync) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.WorkspaceId) != null ? _c : (_b = userAffinityAsync == null ? void 0 : userAffinityAsync.data) == null ? void 0 : _b.workspaceId) != null ? _d : "";
  }
);
const getExperimentationGroupId = createDeepEqualSelector(
  [getWorkspaceId, getManagementGroup],
  (workspaceId, managementGroup) => getExperimentationGroupIdFromPath(workspaceId, managementGroup)
);
const getTreatmentVariables = createDeepEqualSelector(
  [getRootFeatureAsync],
  (rootFeatureAsync) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.Flights) == null ? void 0 : _b.flatMap((f) => f.TreatmentVariables)) != null ? _c : [];
  }
);
const getVariants = createDeepEqualSelector(
  [getRootFeatureAsync],
  (rootFeatureAsync) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.Flights) == null ? void 0 : _b.flatMap((f) => f.Name)) != null ? _c : [];
  }
);
const getMdsControlTowerExperienceAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(
    mdsData,
    [managementGroup, IReducerKeys.mds_control_tower_experience_async],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsAnalysisConfigAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(mdsData, [managementGroup, IReducerKeys.mds_analysis_config_async], getDefaultAsyncWrapperObj())
);
const getAnalysisGroupAsync = createDeepEqualSelector(
  [getExperimentStepId, getAnalysisData],
  (experimentStepId, analysisData) => _.get(
    analysisData,
    [experimentStepId, IReducerKeys.analysis_group_async],
    getDefaultAsyncWrapperObj()
  )
);
const getAnalysisRequestFormAsync = createDeepEqualSelector(
  [getExperimentStepId, getAnalysisData],
  (experimentStepId, analysisData) => _.get(
    analysisData,
    [experimentStepId, IReducerKeys.analysis_request_form_async],
    getDefaultAsyncWrapperObj()
  )
);
const getAnalysisGroupData = createDeepEqualSelector(
  [getAnalysisGroupAsync],
  (analysisGroupAsync) => {
    var _a, _b;
    return (_b = (_a = analysisGroupAsync == null ? void 0 : analysisGroupAsync.data) == null ? void 0 : _a.value) != null ? _b : [];
  }
);
const getAnalysisGroupDataNoValidationMemoizeHelper = createDeepEqualSelector(
  [getAnalysisGroupData],
  (analysisGroupData) => _.map(analysisGroupData, (group) => getAnalysisGroupWithoutValidation(group))
);
const getAnalysisGroupDataNoValidation = createDeepEqualSelector(
  [getAnalysisGroupDataNoValidationMemoizeHelper],
  (analysisGroupData) => analysisGroupData
);
const getAnalysisGroupCreateAsync = createDeepEqualSelector(
  [getExperimentStepId, getAnalysisData],
  (experimentStepId, analysisData) => _.get(
    analysisData,
    [experimentStepId, IReducerKeys.create_analysis_group_async],
    getDefaultAsyncWrapperObj()
  )
);
const isAnalysisGroupsValidating = createDeepEqualSelector(
  [getAnalysisGroupData, getAnalysisGroupCreateAsync],
  (analysisGroupData, { status }) => (
    // mark as new analysis if analysis create status is complete and is the last template in list
    _.some(
      analysisGroupData,
      (group, i) => isAnalysisGroupValidationPending(group, i === analysisGroupData.length - 1 && status === AsyncRequestStatus.Completed)
    )
  )
);
const getAnalysisGroupDeleteData = createDeepEqualSelector(
  [getAnalysisGroupIds, getDeleteAnalysisData],
  (analysisGroupIds, analysisDeleteData) => _.pickBy(analysisDeleteData, (value, key) => analysisGroupIds.includes(key))
);
const getFeatureGateTriggerExpression = createDeepEqualSelector(
  [getMdsAnalysisConfigAsync],
  (analysisConfigAsync) => {
    var _a, _b;
    return (_b = (_a = analysisConfigAsync == null ? void 0 : analysisConfigAsync.data) == null ? void 0 : _a.FeatureGateTriggerCondition) != null ? _b : TriggeredScorecardDefaults.FeatureGateExpression;
  }
);
const getUseVariantForFeatureGateTriggering = createDeepEqualSelector(
  [getMdsAnalysisConfigAsync],
  (analysisConfigAsync) => {
    var _a, _b;
    return EnvironmentService.enableFeatureVariantTriggering() && ((_b = (_a = analysisConfigAsync == null ? void 0 : analysisConfigAsync.data) == null ? void 0 : _a.UseVariantForFeatureGateTriggering) != null ? _b : false);
  }
);
const getMetricsAnalysisTemplatesDataForFeature = createDeepEqualSelector(
  [getMdsAnalysisConfigAsync, getMetricsAnalysisTemplateData],
  (analysisConfigAsync, metricsAnalysisTemplateData) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let returnTemplates = {};
    const analysisRulesTemplateNamesRaw = _.uniq(
      _.map((_a = analysisConfigAsync.data) == null ? void 0 : _a.AnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat()
    );
    const optInTemplateNamesRaw = _.uniq(
      _.map((_c = (_b = analysisConfigAsync.data) == null ? void 0 : _b.OptInAnalysisTemplates) == null ? void 0 : _c.Templates, (template) => template).flat()
    );
    const optOutTemplateNamesRaw = _.uniq(
      _.map((_e = (_d = analysisConfigAsync.data) == null ? void 0 : _d.OptOutAnalysisTemplates) == null ? void 0 : _e.Templates, (template) => template).flat()
    );
    const optInAnalysisRulesTemplateNamesRaw = _.uniq(
      _.map((_f = analysisConfigAsync.data) == null ? void 0 : _f.OptInAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat()
    );
    const optOutAnalysisRulesTemplateNamesRaw = _.uniq(
      _.map((_g = analysisConfigAsync.data) == null ? void 0 : _g.OptOutAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat()
    );
    const analysisRulesTemplateNames = _.reject(analysisRulesTemplateNamesRaw, _.isNil);
    const optInTemplateNames = _.reject(optInTemplateNamesRaw, _.isNil);
    const optOutTemplateNames = _.reject(optOutTemplateNamesRaw, _.isNil);
    const optInAnalysisRulesTemplateNames = _.reject(optInAnalysisRulesTemplateNamesRaw, _.isNil);
    const optOutAnalysisRulesTemplateNames = _.reject(optOutAnalysisRulesTemplateNamesRaw, _.isNil);
    const templatesNames = _.uniq([
      ...analysisRulesTemplateNames,
      ...optInTemplateNames,
      ...optOutTemplateNames,
      ...optInAnalysisRulesTemplateNames,
      ...optOutAnalysisRulesTemplateNames
    ]);
    _.forEach(templatesNames, (name) => returnTemplates[name] = metricsAnalysisTemplateData[name]);
    return returnTemplates;
  }
);
const getRootFeatureAutoTriggerStateData = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureAutoTriggerStateData, featureId) => _.get(
    featureAutoTriggerStateData,
    [featureId, IReducerKeys.feature_auto_trigger_state_async],
    getDefaultAsyncWrapperObj()
  )
);
const getRootFeatureAutoTriggerStateSetData = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureAutoTriggerStateData, featureId) => _.get(
    featureAutoTriggerStateData,
    [featureId, IReducerKeys.set_feature_auto_trigger_state_async],
    getDefaultAsyncWrapperObj()
  )
);
const setMetricsAnalysisTemplatesInReduxWhenLoading = (state = defaultReducerState(), input) => {
  var _a;
  let returnObj = __spreadValues({}, state[IReducerKeys.metrics_analysis_template_data]);
  const templates = _.split((_a = input == null ? void 0 : input.templateName) != null ? _a : "", ",");
  _.forEach(templates, (templateName) => {
    var _a2, _b, _c;
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [templateName]: {
        [IReducerKeys.analysis_template_async]: __spreadProps(__spreadValues({}, (_c = (_b = (_a2 = state == null ? void 0 : state[IReducerKeys.metrics_analysis_template_data]) == null ? void 0 : _a2[input.templateName]) == null ? void 0 : _b[IReducerKeys.analysis_template_async]) != null ? _c : getDefaultAsyncWrapperObj()), {
          status: AsyncRequestStatus.Pending
        })
      }
    });
  });
  return returnObj;
};
const getUnavailableTemplateMessage = (template) => `Cannot load ${template}. This means that at least one analysis was not registered successfully for your experiment. Please verify that the template is valid and spelled correctly (case sensitive) in the Analysis Config section for your Experimentation Group. To update the config, reach out to your experiment champ (aka.ms/exp/ada/support).`;
const setMetricsAnalysisTemplatesInReduxWhenLoaded = (state = defaultReducerState(), resultTemplates, asyncData) => {
  let returnObj = __spreadValues({}, state[IReducerKeys.metrics_analysis_template_data]);
  _.forEach(resultTemplates, (template) => {
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [template.name]: { [IReducerKeys.analysis_template_async]: __spreadProps(__spreadValues({}, asyncData), { data: template }) }
    });
  });
  let availableTemplateNames = resultTemplates.map((rt) => rt.name);
  let requestedTemplateNames = Object.keys(returnObj);
  let unavailableTemplateNames = requestedTemplateNames.filter(
    (requestedTemplate) => !availableTemplateNames.includes(requestedTemplate)
  );
  _.forEach(unavailableTemplateNames, (unavailableTemplateName) => {
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [unavailableTemplateName]: {
        [IReducerKeys.analysis_template_async]: {
          status: AsyncRequestStatus.Failed,
          data: null,
          error: getUnavailableTemplateMessage(unavailableTemplateName)
        }
      }
    });
  });
  return returnObj;
};
const afterLoadAnalysisConfigActions = (AnalysisConfig, workspaceId) => {
  const templateNamesRaw = _.uniq(_.map(AnalysisConfig == null ? void 0 : AnalysisConfig.AnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat());
  const templateNames = _.reject(templateNamesRaw, _.isNil);
  const optInTemplateNamesRaw = _.uniq(_.map(AnalysisConfig == null ? void 0 : AnalysisConfig.OptInAnalysisTemplates, (template) => template).flat());
  const optInTemplateNames = _.reject(optInTemplateNamesRaw, _.isNil);
  const optOutTemplateNamesRaw = _.uniq(_.map(AnalysisConfig == null ? void 0 : AnalysisConfig.OptOutAnalysisTemplates, (template) => template).flat());
  const optOutTemplateNames = _.reject(optOutTemplateNamesRaw, _.isNil);
  const optInAnalysisRulesTemplateNamesRaw = _.uniq(
    _.map(AnalysisConfig == null ? void 0 : AnalysisConfig.OptInAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat()
  );
  const optInAnalysisRulesTemplateNames = _.reject(optInAnalysisRulesTemplateNamesRaw, _.isNil);
  const optOutAnalysisRulesTemplateNamesRaw = _.uniq(
    _.map(AnalysisConfig == null ? void 0 : AnalysisConfig.OptOutAnalysisRules, (rule) => rule.SelectedAnalysisTemplates).flat()
  );
  const optOutAnalysisRulesTemplateNames = _.reject(optOutAnalysisRulesTemplateNamesRaw, _.isNil);
  const allTemplateNames = _.uniq([
    ...templateNames,
    ...optInTemplateNames,
    ...optOutTemplateNames,
    ...optInAnalysisRulesTemplateNames,
    ...optOutAnalysisRulesTemplateNames
  ]);
  const templateNamesString = allTemplateNames.join(",");
  return [loadMetricsAnalysisTemplateEpicReducer.actionCreators.load({ templateName: templateNamesString, workspaceId })];
};
const analysisResourcesInstance = new AnalysisResources();
var IReducerKeys = /* @__PURE__ */ ((IReducerKeys2) => {
  IReducerKeys2["features"] = "features";
  IReducerKeys2["mds_data"] = "mds_data";
  IReducerKeys2["analysis_data"] = "analysis_data";
  IReducerKeys2["metrics_analysis_template_data"] = "metrics_analysis_template_data";
  IReducerKeys2["analysis_delete_data"] = "analysis_delete_data";
  IReducerKeys2["root_feature_async"] = "root_feature_async";
  IReducerKeys2["mds_control_tower_experience_async"] = "mds_control_tower_experience_async";
  IReducerKeys2["mds_analysis_config_async"] = "mds_analysis_config_async";
  IReducerKeys2["analysis_group_async"] = "analysis_group_async";
  IReducerKeys2["create_analysis_group_async"] = "create_analysis_group_async";
  IReducerKeys2["analysis_group_delete_async"] = "analysis_group_delete_async";
  IReducerKeys2["analysis_template_async"] = "analysis_template_async";
  IReducerKeys2["analysis_request_form_async"] = "analysis_request_form_async";
  IReducerKeys2["feature_auto_trigger_state_async"] = "feature_auto_trigger_state_async";
  IReducerKeys2["set_feature_auto_trigger_state_async"] = "set_feature_auto_trigger_state_async";
  return IReducerKeys2;
})(IReducerKeys || {});
const defaultReducerState = () => ({
  [
    "features"
    /* features */
  ]: {},
  [
    "mds_data"
    /* mds_data */
  ]: {},
  [
    "analysis_data"
    /* analysis_data */
  ]: {},
  [
    "analysis_delete_data"
    /* analysis_delete_data */
  ]: {},
  [
    "metrics_analysis_template_data"
    /* metrics_analysis_template_data */
  ]: {}
});
var MasterDataSections = /* @__PURE__ */ ((MasterDataSections2) => {
  MasterDataSections2["AnalysisConfig"] = "AnalysisConfig";
  MasterDataSections2["ControlTowerExperience"] = "ControlTowerExperience";
  MasterDataSections2["ExperimentAlerts"] = "ExperimentAlerts";
  MasterDataSections2["ExperimentExtensions"] = "ExperimentExtensions";
  MasterDataSections2["ExperimentTemplates"] = "ExperimentTemplates";
  MasterDataSections2["ExperimentTrafficFilters"] = "ExperimentTrafficFilters";
  MasterDataSections2["FlightControl"] = "FlightControl";
  MasterDataSections2["JobExecutionMetadata"] = "JobExecutionMetadata";
  MasterDataSections2["MetricSetProperties"] = "MetricSetProperties";
  MasterDataSections2["Monitoring"] = "Monitoring";
  MasterDataSections2["ProgressionTemplates"] = "ProgressionTemplates";
  MasterDataSections2["SystemHealthMessage"] = "SystemHealthMessage";
  MasterDataSections2["TicketCategories"] = "TicketCategories";
  return MasterDataSections2;
})(MasterDataSections || {});
const getMdsSection = (input, section) => {
  const experimentationGroup = getExperimentationGroupIdFromPath(input.workspaceId, input.managementGroup);
  return MdsDataplaneResources.getConfigWithTypeV2({
    workspaceId: input.workspaceId,
    experimentationGroup,
    section
  });
};
const loadRootFeatureArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_FEATURE`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "root_feature_async"
    /* root_feature_async */
  ],
  loadResource: (payload) => FeatureResourcesInstance.loadRootFeatureV2(payload.featureId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    var _a, _b, _c;
    const { ManagementGroup: managementGroup, WorkspaceId: workspaceId } = outputPayload;
    const experimentStepId = (_c = (_b = (_a = outputPayload.Phases) == null ? void 0 : _a[0]) == null ? void 0 : _b.StepIds) == null ? void 0 : _c[0];
    return [
      loadMdsControlTowerExperienceEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
      loadMdsAnalysisConfigEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
      ...EnvironmentService.enableAutoTriggerToggle() ? [loadFeatureAutoTriggerStateEpicReducer.actionCreators.load({ workspaceId, featureId: inputPayload.featureId })] : [],
      ...!!experimentStepId ? [
        loadAnalysisGroupEpicReducer.actionCreators.load({ workspaceId, experimentStepId }),
        loadAnalysisRequestFormEpicReducer.actionCreators.load({ experimentStepId })
      ] : []
    ];
  }
};
const loadRootFeatureEpicReducer = loadResourcesUtils(loadRootFeatureArgs);
const loadMdsControlTowerExperienceArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_MDS_CONTROL_TOWER_EXPERIENCE`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_control_tower_experience_async"
    /* mds_control_tower_experience_async */
  ],
  loadResource: (payload) => getMdsSection(
    payload,
    "ControlTowerExperience"
    /* ControlTowerExperience */
  ),
  onCompleteSuccess: (result) => result
};
const loadMdsControlTowerExperienceEpicReducer = loadResourcesUtils(loadMdsControlTowerExperienceArgs);
const loadMdsAnalysisConfigArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_MDS_ANALYSIS_CONFIG_EXPERIENCE`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_analysis_config_async"
    /* mds_analysis_config_async */
  ],
  loadResource: (payload) => getMdsSection(
    payload,
    "AnalysisConfig"
    /* AnalysisConfig */
  ),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ workspaceId }, AnalysisConfig) => afterLoadAnalysisConfigActions(AnalysisConfig, workspaceId)
};
const loadMdsAnalysisConfigEpicReducer = loadResourcesUtils(loadMdsAnalysisConfigArgs);
const LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX = "LOAD_METRICS_ANALYSIS_TEMPLATE";
const loadMetricsAnalysisTemplateArgs = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "metrics_analysis_template_data",
    inputPayload.templateName,
    "analysis_template_async"
    /* analysis_template_async */
  ],
  loadResource: ({ workspaceId, templateName }) => MetricServiceResource.getAnalysisTemplate(workspaceId, templateName),
  onCompleteSuccess: (result) => result,
  dontLoad(inputPayload, state) {
    return state.progressionScorecard.metrics_analysis_template_data[inputPayload.templateName] ? [AsyncRequestStatus.Completed, AsyncRequestStatus.Pending, AsyncRequestStatus.Failed].includes(
      state.progressionScorecard.metrics_analysis_template_data[inputPayload.templateName][
        "analysis_template_async"
        /* analysis_template_async */
      ].status
    ) : false;
  }
};
const loadMetricsAnalysisTemplateEpicReducer = loadResourcesUtils(loadMetricsAnalysisTemplateArgs);
const loadAnalysisGroupArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_ANALYSIS_GROUP`,
  reduxKeyNested: (inputPayload) => [
    "analysis_data",
    inputPayload.experimentStepId,
    "analysis_group_async"
    /* analysis_group_async */
  ],
  loadResource: (payload) => AnalysisResource.getAnalysisGroup(payload.workspaceId, payload.experimentStepId),
  onCompleteSuccess: (result) => result
};
const loadAnalysisGroupEpicReducer = loadResourcesUtils(loadAnalysisGroupArgs);
const createAnalysisGroupArgs = {
  actionPrefix: `${reduxActionTypePrefix}/CREATE_ANALYSIS_GROUP`,
  reduxKeyNested: (inputPayload) => [
    "analysis_data",
    inputPayload.experimentStepId,
    "create_analysis_group_async"
    /* create_analysis_group_async */
  ],
  loadResource: (payload) => LegacyAnalysisResource.createNewAnalysisGroupsV2(payload.analysisStudyGroupCreateRequest),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => {
    const { workspaceId, experimentStepId } = inputPayload;
    return [loadAnalysisGroupEpicReducer.actionCreators.load({ workspaceId, experimentStepId })];
  }
};
const createAnalysisGroupEpicReducer = loadResourcesUtils(createAnalysisGroupArgs);
const CreateAnalysisGroupWithFeatureAutoTriggerResetArgs = {
  actionPrefix: `${reduxActionTypePrefix}/CREATE_ANALYSIS_GROUP_AND_RESET_FEATURE_AUTO_TRIGGER`,
  reduxKeyNested: (inputPayload) => [
    "analysis_data",
    inputPayload.experimentStepId,
    "create_analysis_group_async"
    /* create_analysis_group_async */
  ],
  loadResource: (payload) => LegacyAnalysisResource.createNewAnalysisGroupsV2(payload.analysisStudyGroupCreateRequest),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => {
    const { workspaceId, featureId } = inputPayload;
    return [setFeatureAutoTriggerStateEpicReducer.actionCreators.load({ workspaceId, featureId, value: false })];
  }
};
const createAnalysisGroupWithFeatureAutoTriggerResetEpicReducer = loadResourcesUtils(
  CreateAnalysisGroupWithFeatureAutoTriggerResetArgs
);
const loadAnalysisRequestFormArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_ANALYSIS_REQUEST_FORM`,
  reduxKeyNested: (inputPayload) => [
    "analysis_data",
    inputPayload.experimentStepId,
    "analysis_request_form_async"
    /* analysis_request_form_async */
  ],
  loadResource: (payload) => analysisResourcesInstance.getAnalysisRequestForm(payload.experimentStepId, false),
  onCompleteSuccess: (result) => result
};
const loadAnalysisRequestFormEpicReducer = loadResourcesUtils(loadAnalysisRequestFormArgs);
const deleteAnalysisGroupArgs = {
  actionPrefix: `${reduxActionTypePrefix}/DELETE_ANALYSIS_GROUP`,
  reduxKeyNested: ({ analysisGroupId }) => [
    "analysis_delete_data",
    analysisGroupId,
    "analysis_group_delete_async"
    /* analysis_group_delete_async */
  ],
  loadResource: ({ workspaceId, analysisGroupId, analysisTemplateNames }) => {
    return AnalysisResource.deleteAnalysisGroup(workspaceId, analysisGroupId, analysisTemplateNames);
  },
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ analysisGroupId, allAnalysisGroupIds, experimentStepId, workspaceId }, outputPayload, state) => {
    const _a = getAnalysisGroupDeleteData(state, {
      analysisGroupIds: allAnalysisGroupIds
    }), { [analysisGroupId]: current } = _a, restAnalysisGroupDeleteData = __objRest(_a, [__restKey(analysisGroupId)]);
    const statuses = ___default.map(restAnalysisGroupDeleteData, (value) => {
      var _a2;
      return (_a2 = value == null ? void 0 : value["analysis_group_delete_async"]) == null ? void 0 : _a2.status;
    });
    const completed = allRequestsHaveCompleted(statuses);
    return completed ? [loadAnalysisGroupEpicReducer.actionCreators.load({ experimentStepId, workspaceId })] : [];
  }
};
const deleteAnalysisGroupEpicReducer = loadResourcesUtils(deleteAnalysisGroupArgs);
const editAnalysisGroupArgs = {
  actionPrefix: `${reduxActionTypePrefix}/EDIT_ANALYSIS_GROUP`,
  reduxKeyNested: (inputPayload) => [
    "analysis_data",
    inputPayload.experimentStepId,
    "create_analysis_group_async"
    /* create_analysis_group_async */
  ],
  loadResource: (payload) => LegacyAnalysisResource.createNewAnalysisGroupsV2(payload.analysisStudyGroupCreateRequest),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => [
    deleteAnalysisGroupEpicReducer.actionCreators.load(__spreadProps(__spreadValues({}, inputPayload), { allAnalysisGroupIds: [inputPayload.analysisGroupId] }))
  ]
};
const editAnalysisGroupEpicReducer = loadResourcesUtils(editAnalysisGroupArgs);
const LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX = "LOAD_FEATURE_AUTO_TRIGGER_STATE";
const loadFeatureAutoTriggerStateArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "feature_auto_trigger_state_async"
    /* feature_auto_trigger_state_async */
  ],
  loadResource: (payload) => {
    const { workspaceId, featureId } = payload;
    return AnalysisResource.getFeatureAutoTriggeringState(workspaceId, featureId);
  },
  onCompleteSuccess: (result) => {
    return result;
  },
  onLoaded: (response) => {
    if (!!response && response.statusCode == 404) {
      const featureAutoTriggerStateResult = {
        value: false,
        error: {
          code: "404",
          message: "Not Found"
        }
      };
      return {
        isSuccessful: true,
        data: featureAutoTriggerStateResult
      };
    }
  }
};
const loadFeatureAutoTriggerStateEpicReducer = loadResourcesUtils(loadFeatureAutoTriggerStateArg);
const SET_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX = "SET_FEATURE_AUTO_TRIGGER_STATE";
const setFeatureAutoTriggerStateArg = {
  actionPrefix: `${reduxActionTypePrefix}/${SET_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "set_feature_auto_trigger_state_async"
    /* set_feature_auto_trigger_state_async */
  ],
  loadResource: (payload) => {
    const { workspaceId, featureId, value } = payload;
    return AnalysisResource.setFeatureAutoTriggeringState(workspaceId, featureId, value);
  },
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (payload) => {
    const { workspaceId, featureId } = payload;
    return [loadFeatureAutoTriggerStateEpicReducer.actionCreators.load({ workspaceId, featureId })];
  }
};
const setFeatureAutoTriggerStateEpicReducer = loadResourcesUtils(setFeatureAutoTriggerStateArg);
const reducer = (state = defaultReducerState(), action) => {
  var _a, _b;
  state = loadRootFeatureEpicReducer.reduxChange(state, action);
  state = loadMdsControlTowerExperienceEpicReducer.reduxChange(state, action);
  state = loadMdsAnalysisConfigEpicReducer.reduxChange(state, action);
  state = loadAnalysisGroupEpicReducer.reduxChange(state, action);
  state = createAnalysisGroupEpicReducer.reduxChange(state, action);
  state = deleteAnalysisGroupEpicReducer.reduxChange(state, action);
  state = editAnalysisGroupEpicReducer.reduxChange(state, action);
  state = createAnalysisGroupWithFeatureAutoTriggerResetEpicReducer.reduxChange(state, action);
  state = loadAnalysisRequestFormEpicReducer.reduxChange(state, action);
  state = loadFeatureAutoTriggerStateEpicReducer.reduxChange(state, action);
  state = setFeatureAutoTriggerStateEpicReducer.reduxChange(state, action);
  if (action.type === `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}/LOADING`) {
    state = __spreadProps(__spreadValues({}, state), {
      [
        "metrics_analysis_template_data"
        /* metrics_analysis_template_data */
      ]: __spreadValues({}, setMetricsAnalysisTemplatesInReduxWhenLoading(state, action.payload))
    });
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_METRICS_ANALYSIS_TEMPLATE_PREFIX}/LOADED`) {
    state = __spreadProps(__spreadValues({}, state), {
      [
        "metrics_analysis_template_data"
        /* metrics_analysis_template_data */
      ]: __spreadValues({}, setMetricsAnalysisTemplatesInReduxWhenLoaded(state, (_b = (_a = action.outputPayloadAsync) == null ? void 0 : _a.data) != null ? _b : [], action.outputPayloadAsync))
    });
  }
  return state;
};
const epics = combineEpics(
  loadRootFeatureEpicReducer.epic,
  loadMdsControlTowerExperienceEpicReducer.epic,
  loadMdsAnalysisConfigEpicReducer.epic,
  loadAnalysisGroupEpicReducer.epic,
  createAnalysisGroupEpicReducer.epic,
  deleteAnalysisGroupEpicReducer.epic,
  editAnalysisGroupEpicReducer.epic,
  createAnalysisGroupWithFeatureAutoTriggerResetEpicReducer.epic,
  loadMetricsAnalysisTemplateEpicReducer.epic,
  loadAnalysisRequestFormEpicReducer.epic,
  loadFeatureAutoTriggerStateEpicReducer.epic,
  setFeatureAutoTriggerStateEpicReducer.epic
);
export {
  getAnalysisGroupData as $,
  getSupportedTriggerType as A,
  parseFeatureTriggerValues as B,
  setFeatureAutoTriggerStateEpicReducer as C,
  getVariantTriggerCondition as D,
  getFeatureGateTriggerCondition as E,
  getAnalysisRequestFormAsync as F,
  getVariants as G,
  ValidationRequestStatus as H,
  IReducerKeys as I,
  parseAutomaticAnalysis as J,
  parseAutomaticAnalysisWithFeatureAutoTriggerState as K,
  parseAnalysisCondition as L,
  getBaseValuesAndOperator as M,
  getAnalysisTemplateWithoutValidation as N,
  getAnalysisGroupWithoutValidation as O,
  isAnalysisTemplateValidationComplete as P,
  isAnalysisGroupValidationPending as Q,
  convertTasksToDateRangeUnits as R,
  getFeatureId as S,
  getAnalysisGroupIds as T,
  getFeaturesData as U,
  ValidationStatus as V,
  getMdsData as W,
  getAnalysisData as X,
  getMetricsAnalysisTemplateData as Y,
  getUserAffinity as Z,
  getManagementGroup as _,
  getMdsAnalysisConfigAsync as a,
  getAnalysisGroupDeleteData as a0,
  getRootFeatureAutoTriggerStateSetData as a1,
  setMetricsAnalysisTemplatesInReduxWhenLoading as a2,
  getUnavailableTemplateMessage as a3,
  setMetricsAnalysisTemplatesInReduxWhenLoaded as a4,
  afterLoadAnalysisConfigActions as a5,
  defaultReducerState as a6,
  MasterDataSections as a7,
  getMdsSection as a8,
  loadMdsControlTowerExperienceEpicReducer as a9,
  loadMdsAnalysisConfigEpicReducer as aa,
  loadMetricsAnalysisTemplateEpicReducer as ab,
  loadAnalysisRequestFormEpicReducer as ac,
  LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX as ad,
  loadFeatureAutoTriggerStateEpicReducer as ae,
  SET_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX as af,
  getAnalysisGroupAsync as b,
  getMdsControlTowerExperienceAsync as c,
  getMetricsAnalysisTemplatesDataForFeature as d,
  epics as e,
  getRootFeatureAutoTriggerStateData as f,
  getRootFeatureAsync as g,
  loadAnalysisGroupEpicReducer as h,
  isAnalysisGroupsValidating as i,
  getWorkspaceId as j,
  getExperimentStepId as k,
  loadRootFeatureEpicReducer as l,
  getExperimentationGroupId as m,
  getAnalysisGroupDataNoValidation as n,
  getDeleteAnalysisData as o,
  getAnalysisGroupCreateAsync as p,
  getProgressionScorecardItems as q,
  reducer as r,
  deleteAnalysisGroupEpicReducer as s,
  getSelectionString as t,
  getTreatmentVariables as u,
  getFeatureGateTriggerExpression as v,
  getUseVariantForFeatureGateTriggering as w,
  createAnalysisGroupEpicReducer as x,
  editAnalysisGroupEpicReducer as y,
  createAnalysisGroupWithFeatureAutoTriggerResetEpicReducer as z
};
//# sourceMappingURL=ProgressionScorecard.ducks-eff9590e.js.map
